// extracted by mini-css-extract-plugin
export default {"container":"src-pages-SalesChannelContentEditor-SalesChannelEditorProfilePage-TopConfigs-css__container--Pvpf0"};